export const environment = {
  production: false,  // Set to false unless you want it to behave like production
  apiBaseUrl: 'https://staging.backend.pulseright.io',
  loggingEnabled: false, // Disable verbose logging in staging
  featureFlagX: true,     // Enable or disable features
};
